import { PureReturnOrders } from '../ReturnOrders/PureReturnOrders';

interface NewReturnOrdersProps {
  relatedTradeId: string;
  storeId: string;
  platform: General.PlatformUpperCase;
  externalBuyerId: string;
  readonly?: boolean;
  relatedReturnId?: string;
  onChange: (relatedReturnId: string) => void;
}

export const NewReturnOrders = (props: NewReturnOrdersProps) => {
  const {
    relatedTradeId,
    storeId,
    platform,
    externalBuyerId,
    readonly = false,
    onChange,
    relatedReturnId,
  } = props;

  return (
    <PureReturnOrders
      relatedTradeId={relatedTradeId}
      storeId={storeId}
      platform={platform}
      externalBuyerId={externalBuyerId}
      readonly={readonly}
      onChange={onChange}
      returnSn={relatedReturnId}
      autoSelectFirst
    />
  );
};
